// LuxPlus Singapore Airlines Mastercard Takeover Constants
// This takeover runs as a separate campaign from DSC (Double Status Credits)
// Campaign valid: After 23 Dec AEST until 5 Jan 2026, 11:59pm

export const LUX_PLUS_SIA_MASTERCARD_TAKEOVER_ID = 'luxplus-sia-mastercard'
export const LUX_PLUS_SIA_MASTERCARD_CAMPAIGN_ID = 'LuxPlus+ SIA Mastercard'

// Campaign end date: 26 Jan 2026, 11:59pm AEST (UTC+11)
export const LUX_PLUS_SIA_MASTERCARD_CAMPAIGN_END_DATE = new Date('2026-01-26T23:59:59+11:00')

// Campaign start date: 12 Jan AEST
export const LUX_PLUS_SIA_MASTERCARD_CAMPAIGN_START_DATE = new Date('2026-01-12T00:00:00+11:00')

// URLs
export const LUX_PLUS_SIA_MASTERCARD_FLIGHTS_URL = '/campaign/luxplus-exclusive-singapore-airlines-offer'

// Savings copy
export const LUX_PLUS_SIA_MASTERCARD_SAVINGS_COPY = 'up to $300 off Singapore Airlines flights'
